import React from 'react'
import { Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer'
import { CGV, CustomerAddress, DocumentDate, Footer, Header, style } from '../../document/DocumentPDF'

const ContractPDF = ({ contract_param: contract, company_param: company, logo_param: img }) => {
  const customer = contract.customer
  const styles = StyleSheet.create(style)

  const References = () => {
    if (contract) {
      return (
        <>
          <View style={styles.rightContainer}>
            <Text style={styles.boldWithSpace}>Référence contrat</Text>
            <Text style={styles.address}>{contract.contract_number}</Text>
          </View>
        </>
      )
    }
  }

  const ContractPayment = () => (
    <View style={{ marginTop: 20 }}>
      <Text style={styles.conditions}>
        Conditions et règlement de paiement : Prélèvement bancaire mensuel fixe à date de souscription{' '}
      </Text>
    </View>
  )

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <View fixed>
          <Header styles={styles} title={'CONTRAT'} img={img} />
          <References />
          <DocumentDate date={contract.contract_date} styles={styles} />
        </View>
        <View style={{ flex: 0.8, marginBottom: '5px', paddingBottom: '10px' }}>
          <CustomerAddress styles={styles} company={company} customer={customer} />
          <ContractPayment />
        </View>
        <Footer company={company} styles={styles} />
      </Page>
      <CGV customer={customer} company={company} styles={styles} />
    </Document>
  )
}

export default React.memo(ContractPDF)
